import { AuthProvider, CrudGetListAction, CrudGetOneAction, CRUD_CREATE, CRUD_DELETE, 
  CRUD_GET_LIST, CRUD_GET_MANY, CRUD_GET_ONE, CRUD_UPDATE } from "ra-core";
import { eventChannel } from "redux-saga";
import { all, call, delay, put, takeLatest } from "redux-saga/effects";
import { push } from "connected-react-router"


// TX.RAMP AC-12 'Session Timeout'
// should terminate a user session after 30 minutes of inactivity
// 
// here we define 'inactivity' as no detection of any of the following activities:
// * page routes
// * api calls (with a few exceptions being polling reqs)
// * ui events (like click, input, etc)

const KEEP_POSITIVE_MINS = 30

const writeChannel = new BroadcastChannel('auth')
const readChannel = new BroadcastChannel('auth')

const pollingRes = {
  [CRUD_GET_ONE]: {
    'noop': true,
    'settings/organization/cloud-subscription': true,
    'deployments/list': true,
  } as Record<string, boolean>,
  [CRUD_GET_LIST]: {
    'noop': true,
    'dbmetrics-vmcpu': true,
    'dbmetrics-vmmemory': true,
    'dbmetrics-vmdisk': true,
    'encryption-historic-recs': true,
    'obfuscation-historic-recs': true,
    'backup-recs': true,
    'deployments/list': true,
    'db-esc-status': true,
    'dbmetrics-maxquerytime': true,
    'dbmetrics-averagequerytime': true,
    'dbmetrics-queryerrors': true,
    'settings/deployment/network-configuration': true,
  } as Record<string, boolean>,
}


const notables = {
  '@@router/LOCATION_CHANGE': true,
  [CRUD_CREATE]: true,
  [CRUD_UPDATE]: true,
  [CRUD_DELETE]: true,
  [CRUD_GET_LIST]: (action:CrudGetListAction) => {
    const res = action.meta.resource
    return !(pollingRes[CRUD_GET_LIST][res])
  },
  [CRUD_GET_ONE]: (action:CrudGetOneAction) => {
    const res = action.meta.resource
    return !(pollingRes[CRUD_GET_ONE][res])
  },
  [CRUD_GET_MANY]: true,
} as any

function* reportKeepPositive () {
  yield delay(5000)
  writeChannel.postMessage({ kind: 'keep_positive' })
}

function keepPositiveCountdown (authProvider:AuthProvider) {
  const kpSignal = () => {
    return eventChannel((input:any) => {
      const listener = (ev:any) => {
        if (!ev.data || typeof ev.data.kind !== 'string') { return }
        if (ev.data.kind === 'keep_positive') {
          input(1)
        }
      }
      readChannel.addEventListener('message', listener)

      return () => {
        readChannel.removeEventListener('message', listener)
      }
    })
  }
  return takeLatest(kpSignal(), function* () {
    yield delay(KEEP_POSITIVE_MINS * 60 * 1000)
    yield call([authProvider, 'logout'], undefined)
    yield put(push('/login'))
  })
}


const takeActivityAction = (action:any) => {
  const type = action.type
  if (!type) { return false }
  const fn = notables[type]
  if (!fn) { return false }
  else if (fn instanceof Function) {
    return !!fn(action)
  } else {
    return !!fn
  }
}

export default function* keepPositiveSaga(authProvider:AuthProvider) {
  yield all([
    takeLatest(takeActivityAction, reportKeepPositive),
    keepPositiveCountdown (authProvider)
  ])
}
